import React from "react";
import { useState, useEffect } from "react";

import {  withStyles } from 'tss-react/mui';
import { Paper } from '@mui/material';

import ListItemIcon from '@mui/material/ListItemIcon';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';

const useStyles = (theme, props) => ({
    paper:{
        display:'flex',
        flexDirection: 'column',
        gap:'5px'
        // border: '1px solid red'
    },
    item:{
        display: 'flex',
        alighItems: 'center',
        // border: '1px solid purple'
    },
    validItem: {
        color: 'green',
    },
    invalidItem: {
        color: 'red',
    },
});


const PasswordRequirementsDialog = ({sendDataToParent, password, passwordConfirm, classes}) => {

    const [open, setOpen] = useState(false)

    // eslint-disable-next-line
    const requirements = [
        { 
            label: 'Mínimo 8 caracteres', 
            valid: password.length >= 8 
        },
        { 
            label: 'Máximo de 20 caracteres', 
            valid: password.length <=20
        },
        { 
            label: 'Letra maiúscula (A-Z)', 
            valid: /[A-Z]/.test(password) 
        },
        { 
            label: 'Letra minúscula (a-z)', 
            valid: /[a-z]/.test(password) 
        },
        { 
            label: 'Número (0-9)', 
            valid: /[0-9]/.test(password) 
        },
        { 
            label: 'Caractere especial (@$!%*?&)', 
            valid: /[@$!%*?&]/.test(password) 
        },
        { 
            label: 'Senhas devem ser iguais', 
            valid: (password === passwordConfirm && password!=="")
        },
    ]

    useEffect(()=>{
        let requirementsOk = true
        for (const item in requirements){
            if (!requirements[item].valid){
                requirementsOk = false
                setOpen(true)
            }
            
            sendDataToParent({passwordRequirementOk:requirementsOk})
            if (requirementsOk === true){
                setOpen(false)
            }
        }
        // eslint-disable-next-line
    },[password, passwordConfirm])

    if (open && (password!==""|| passwordConfirm!=="")){

    return(
        <Paper className={classes.paper} elevation={0} >
                {requirements.map((T,I) => (
                    <div className={classes.item}>
                    <ListItemIcon>{T.valid? <CheckCircleIcon className={classes.validItem} />:<ErrorIcon className={classes.invalidItem} />}</ListItemIcon>
                    <b className={T.valid? classes.validItem: classes.invalidItem}>{T.label}</b>
                    </div>
                ))}

        </Paper>

    )}
    else{
        return(<></>)
    }
        

};

export default withStyles(PasswordRequirementsDialog, useStyles);